import { Component, OnInit } from "@angular/core";
import { DoctypeService, DocType } from "../doctype-service/doctype.service";
import { AuthService } from "src/app/auth-section/auth-service/auth.service";
import { take } from "rxjs/operators";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { ConfirmationService } from "primeng/api";

@Component({
  selector: "app-doctype",
  templateUrl: "./doctype.component.html",
  styleUrls: ["./doctype.component.css"],
  providers: [ConfirmationService],
})
export class DoctypeComponent implements OnInit {
  isData = false;
  token: any;
  dbForm: FormGroup;
  doctypeArray = [];
  constructor(
    private doctorService: DoctypeService,
    private authService: AuthService,
    private conformationService: ConfirmationService
  ) {}

  ngOnInit() {
    this.authService.authDataSubject.pipe(take(1)).subscribe((authData) => {
      this.token = authData._token;
      console.log(authData._token);
    });
    this.rightlist();
    this.onInitForm();
  }

  rightlist(){
    this.doctorService.getDocType(this.token).subscribe((res) => {
      this.doctypeArray = res;
      if (this.doctypeArray) {
        this.isData = this.doctypeArray.length > 0 ? true : false;
      }
    });   

  }
  onSubmit() {
    const name = this.dbForm.value["DoctorType"];
    const doctorCategory = this.dbForm.value["doctorCategory"];
   const symptoms=this.dbForm.value["symptoms"];
    const slug = this.dbForm.value["slug"];

    this.doctorService
      .saveDocType(name, this.token, doctorCategory, slug,symptoms)
      .subscribe((resData) => {
        console.log(resData);
        // this.doctypeArray.push({ name: name });
        this.rightlist();
        this.onInitForm();
      });
  }
  onInitForm() {
    this.dbForm = new FormGroup({
      DoctorType: new FormControl(null, Validators.required),
      slug: new FormControl(null, Validators.required),
      doctorCategory: new FormControl(null, Validators.required),
      symptoms: new FormControl(null, Validators.required)
    });
  }
  onDelete(index) {
    const typeId = this.doctypeArray[index]._id;
    this.conformationService.confirm({
      message: "Are you sure that you want to perform this action?",
      accept: () => {
        this.doctorService.onDelete(typeId, this.token).subscribe((res) => {
          this.doctypeArray.splice(index, 1);
        });
      },
    });
  }
}
